import angular from 'angular';
import { features } from '@/shared/services/AuthService';

angular
  .module('cloudX')
  .controller('ConfigFieldDialogCtrl', [
    'resourceFactorySvc',
    'flySvc',
    'close',
    'field',
    'fields',
    ConfigFieldDialogCtrl,
  ]);

function ConfigFieldDialogCtrl(resourceFactorySvc, flySvc, close, field, fields) {
  var validatorTypes = [1, 2, 3, 5, 6, 7, 8, 37, 38, 41, 44, 86];
  var inputMaskTypes = [5, 6, 7, 37, 38, 44];
  var vm = this;
  vm.editMode = !!field.id;
  vm.fields = angular.copy(fields);

  vm.field = angular.copy(field);

  vm.featureOptions = Object.keys(features)
    .map(function(key) {
      return { id: features[key], label: key };
    })
    .sort(function(a, b) {
      return a.label.localeCompare(b.label);
    });
  vm.selectedFeatures =
    vm.field.features === 0
      ? []
      : vm.featureOptions.filter(function(o) {
          // eslint-disable-next-line no-bitwise
          return ((vm.field.features || 0) & o.id) !== 0;
        });
  vm.updateFeatures = function() {
    vm.field.features = vm.selectedFeatures.reduce(function(acc, x) {
      return acc + x.id;
    }, 0);
  };
  vm.searchFeatures = function(query) {
    if (!query) return vm.featureOptions;
    var q = query.toLowerCase();
    return vm.featureOptions.filter(function(x) {
      return x.label.toLowerCase().indexOf(q) >= 0;
    });
  };

  vm.save = function() {
    if (vm.editMode)
      resourceFactorySvc.get('field').update(
        vm.field,
        function() {
          close(vm.field, 500);
          flySvc.success('Field updated');
        },
        function(response) {
          flySvc.error(response.data.exceptionMessage);
        },
      );
    else
      resourceFactorySvc.get('field').save(
        vm.field,
        function(data) {
          close(data, 500);
          flySvc.success('Field added');
        },
        function(response) {
          flySvc.error(response.data.exceptionMessage);
        },
      );
  };
  vm.cancel = function() {
    close(null, 500);
  };
  vm.delete = function() {
    resourceFactorySvc.get('field').delete(
      {
        id: vm.field.id,
      },
      function() {
        vm.field.removed = true;
        close(vm.field, 500);
        flySvc.success('Field config removed');
      },
      function(response) {
        flySvc.error(response.data.exceptionMessage);
      },
    );
  };

  vm.showValidators = function(type) {
    return validatorTypes.indexOf(type) >= 0;
  };
  vm.deleteValidation = function(index) {
    if (index > -1) vm.field.validators.splice(index, 1);
  };
  vm.addValidation = function() {
    if (!vm.field.validators) vm.field.validators = [];
    vm.field.validators.push({});
  };

  vm.showInputMasks = function(type) {
    return inputMaskTypes.indexOf(type) >= 0;
  };
  vm.deleteInputMask = function(country) {
    if (!country) return;
    country = country.toUpperCase();
    delete vm.field.inputMasks[country];
  };
  vm.addInputMask = function(country) {
    if (!country) return;
    country = country.toUpperCase();
    if (!vm.field.inputMasks) vm.field.inputMasks = {};
    if (vm.field.inputMasks.hasOwnProperty(country)) return;
    vm.field.inputMasks[country] = '';
  };
}
